import {
  isValidIsoString,
  TimeQuestionConfig,
  TimeResponseState,
} from '@gripp/shared-logic';
import { t } from 'i18next';
import { useEffect, useRef } from 'react';
import { DateRangeSelector, useFormContext } from '../../../../../forms';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../../types';

export const StartEndTime: RoutineQuestionExecutionForm<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    TimeQuestionConfig,
    TimeResponseState
  >
) => {
  const startTimeFieldPrefix = `responses.${props.responseIndex}.timeTypeValue.startTime`;
  const endTimeFieldPrefix = `responses.${props.responseIndex}.timeTypeValue.endTime`;
  const keyRefresh = useRef<string>('timeOnly');

  const { control, setValue } = useFormContext();
  useEffect(() => {
    if (!props.isIssueEditRoutine) return;
    const start =
      props.currentState?.state?.responses?.[props.responseIndex]?.timeTypeValue
        ?.startTime;
    const end =
      props.currentState?.state?.responses?.[props.responseIndex]?.timeTypeValue
        ?.endTime;
    if (isValidIsoString(start) && isValidIsoString(end)) {
      setValue(
        endTimeFieldPrefix,
        props.currentState?.state?.responses?.[props.responseIndex]
          ?.timeTypeValue.endTime,
        {
          shouldDirty: false,
          shouldValidate: false,
          shouldTouch: false,
        }
      );
      setValue(
        startTimeFieldPrefix,
        props.currentState?.state?.responses?.[props.responseIndex]
          ?.timeTypeValue.startTime,
        {
          shouldDirty: false,
          shouldValidate: false,
          shouldTouch: false,
        }
      );
      keyRefresh.current = 'timeOnly-refresh';
    }
  }, [props.currentState, props.isIssueEditRoutine]);

  return (
    <DateRangeSelector
      key={keyRefresh.current}
      control={control}
      setValue={setValue}
      startDateName={startTimeFieldPrefix}
      endDateName={endTimeFieldPrefix}
      mode="time"
      labelStart={`${t('routines.time.admin.labelStartTime')}`}
      labelEnd={`${t('routines.time.admin.labelEndTime')}`}
    />
  );
};
